module.exports = __webpack_public_path__ + "img/gorila_no.da412b75.png";